// extracted by mini-css-extract-plugin
export default {"container":"mmlmF","header":"_2sA_2","content":"_1DXEd","controls":"ZOHE4"};